class TooltipManagerClass {
    constructor() {
        this._lastOpenTooltip = null;
    }

    setLastOpenTooltip(widget) {
        this._lastOpenTooltip = widget;
    }

    getLastOpenTooltip() {
        return this._lastOpenTooltip;
    }
}

export default new TooltipManagerClass();